import { Component } from '@angular/core';
import { AddNewUtilityModel } from '../../../models/module.model';
import { ModuleService } from '../../../services/module.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-new-module',
  templateUrl: './add-new-module.component.html',
  styleUrl: './add-new-module.component.scss',
  standalone: false
})
export class AddNewModuleComponent {
  name: string = '';
  description: string = '';
  color: string = '';
  image: File;
  icon: File | null = null;
  iconPath: string | null = null;

  iconUrl: string;
  imageUrl: string;

  circleColors: string[] = [
    '#EF4444',
    '#F97316',
    '#FACC15',
    '#4ADE80',
    '#2DD4BF',
    '#3B82F6',
    '#6366F1',
    '#EC4899',
    '#F43F5E',
    '#D946EF',
    '#8B5CF6',
    '#0EA5E9',
    '#10B981',
    '#84CC16',
    '#160CC9',
    '#01552A'
  ]

  constructor(private moduleService: ModuleService, private toastrService: ToastrService) {}

  onColorChange(event: any) {
    this.color = event.color?.hex || event.target.value;
  }

  selectColorCircle(color: string, index: number) {
    this.color = color;
  }

  handleSvgFile(file: File | string) {
    if (file instanceof File) {
      this.iconPath = null;  
      this.icon = file;
    }
    else if (typeof file === 'string') {
      this.icon = null;
      this.iconPath = file;
       this.iconPath = this.iconPath.replace("asset-icons", "asset-icons-light");
    }
  }
  
  handleImgFile(file: File) {
    this.image = file;
  }

  onSave() {
    const data = new AddNewUtilityModel({
      name: this.name,
      description: this.description,
      moduleImage: this.image,
      color: this.color
    });

    if (this.icon)
      data.icon = this.icon;

    if (this.iconPath)
      data.iconPath = this.iconPath;

    if(!this.validateModule(data))
      return

    this.moduleService.addNewModule(data).subscribe({
      next: (data) => {
        if (data?.body.status == 'OK' || data?.body.status == 200)
          this.toastrService.success("New module added succesfully.")
      }
    })
  }

  private validateModule(data: AddNewUtilityModel): boolean {
    if (!data.name) {
      this.toastrService.info("Name is requred.");
      return false;
    } else if (!data.description) {
      this.toastrService.info("Description is required");
      return false;
    } else if (!data.color){      
      this.toastrService.info("Color is required.")
      return false;
    } else if (!data.moduleImage) {
      this.toastrService.info("Module image is required.");
      return false;
    } else if (!data.icon && !data.iconPath) {
      this.toastrService.info("Icon is required.")
      return false;
    }

    return true;
  }
}
